import React, { RefObject, useState } from 'react';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { SporsmalHeader } from '../../components/sporsmal-header/sporsmal-header';
import { FocusableHtmlElement } from '../hooks';
import { addSporsmalListSporsmalsflytCollection, toggleSporsmalListItem } from '../reducer/sporsmalsflyt-actions';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentSporsmalList, sporsmalListValid } from './sporsmalList-types';
import { SporsmalListExpandCard } from './sporsmalListExpandCard';

import './sporsmal-list.scss';

interface SporsmalListProps {
    currentSporsmalList: CurrentSporsmalList;
    showFeilmeldinger: boolean;
    focusOnMount: boolean;
    onNext: () => void;
    addCollectionButtonLabel: string;
    removeButtonLabel: string;
    errorRef?: RefObject<FocusableHtmlElement>;
}

export const SporsmalList = ({
    currentSporsmalList,
    showFeilmeldinger,
    onNext,
    addCollectionButtonLabel,
    removeButtonLabel,
    errorRef,
    focusOnMount = true,
}: SporsmalListProps) => {
    const [showListFeilmeldinger, setShowListFeilmeldinger] = useState(false);
    const sporsmalflytDispatch = useSporsmalsflytDispatch();

    const addSporsmalsflytCollection = () => {
        if (!sporsmalListValid(currentSporsmalList.sporsmalListSporsmalsflytCollection)) {
            setShowListFeilmeldinger(true);
        } else {
            setShowListFeilmeldinger(false);
            sporsmalflytDispatch(addSporsmalListSporsmalsflytCollection());
        }
    };

    const validateBeforeToggle = (id: string) => {
        if (!sporsmalListValid(currentSporsmalList.sporsmalListSporsmalsflytCollection)) {
            setShowListFeilmeldinger(true);
            if (errorRef.current) {
                errorRef.current.focus();
            }
        } else {
            setShowListFeilmeldinger(false);
            sporsmalflytDispatch(toggleSporsmalListItem(id));
        }
    };

    return (
        <SporsmalHeader tittel={currentSporsmalList.sporsmal?.tittel} ingress={currentSporsmalList.sporsmal?.ingress}>
            {currentSporsmalList.sporsmalListSporsmalsflytCollection && (
                <ul className="sporsmal-list-sporsmal">
                    {currentSporsmalList.sporsmalListSporsmalsflytCollection.map((sporsmalflytCollection, key) => (
                        <li className="sporsmal-list-sporsmal--sporsmal" key={`sporsmal-list-collection-${key + 1}`}>
                            <SporsmalListExpandCard
                                sporsmalflytCollection={sporsmalflytCollection}
                                showFeilmeldinger={showFeilmeldinger || showListFeilmeldinger}
                                onNext={onNext}
                                tittelFeltid={currentSporsmalList.sporsmal.tittelFeltId}
                                subTittelFeltid={currentSporsmalList.sporsmal.subTittelFeltId}
                                showDeleteBtn={currentSporsmalList.sporsmalListSporsmalsflytCollection.length > 1}
                                toggle={validateBeforeToggle}
                                focusOnMount={focusOnMount}
                                removeButtonLabel={removeButtonLabel}
                                errorRef={errorRef}
                            />
                        </li>
                    ))}
                </ul>
            )}
            <LinkButton
                id="sporsmal-list-add-btn-id"
                className="sporsmal-list-add-btn"
                onClick={addSporsmalsflytCollection}
                icon={IconTypes.PLUSS_24}
            >
                {addCollectionButtonLabel}
            </LinkButton>
        </SporsmalHeader>
    );
};
